import { render, staticRenderFns } from "./AuthPrivilegeList.vue?vue&type=template&id=68d0562c&scoped=true&"
import script from "./AuthPrivilegeList.vue?vue&type=script&lang=js&"
export * from "./AuthPrivilegeList.vue?vue&type=script&lang=js&"
import style0 from "./AuthPrivilegeList.vue?vue&type=style&index=0&id=68d0562c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d0562c",
  null
  
)

export default component.exports